import { NgModule, ViewChildren } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../guards/auth.guard';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NotificationViewComponent } from '../notification/notification-view/notification-view.component';


const routes: Routes = [
  { path: 'dashboard' , component: DashboardComponent  , children : [
 
  {
    path: 'basic-data', loadChildren: () => import('../basic-data/basic-data.module').then(m => m.BasicDataModule)
  },
  {
    path: 'admin', loadChildren: () => import('../account/account.module').then(m => m.AccountModule)
  }
  ,
  { path: 'notification', children:
  [
    { path: 'notification-view', component: NotificationViewComponent } ,
    { path: '', component: NotificationViewComponent }

  
  ] }
]},




];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
